<script>
	import { onMount } from 'svelte'
	import next from 'array-next'
	import { fade, fly } from 'svelte/transition'
	import { sineInOut } from 'svelte/easing'
	import sal from 'sal.js'

	export let info
	// console.log('info:', info)
	let projects = info.featured_projects
	let backdropText = info.backdrop_text

	let activeProject = projects[0]

	$: activeProjects = [activeProject]

	function getProject() {
		activeProject = next(projects, activeProject)
	}

	let slideint

	onMount(() => {
		sal()
		slideint = setInterval(getProject, 5000)
	})
</script>

<div id="home-s3" class="section-full">
	{#if backdropText}
		<span class="backdrop-text" data-sal="slide-right">{backdropText}</span>
	{/if}
	{#each activeProjects as item (item.title)}
		<div
			class="hp-slide bg-img"
			style="background-image: url({item.image})"
			in:fade={{ duration: 650, easing: sineInOut }}
			out:fade={{ duration: 750, easing: sineInOut }} />
	{/each}

	<div
		class="home-project-wrap"
		data-sal="slide-right"
		data-sal-delay="200"
		data-sal-duration="1000">
		{#each activeProjects as item (item.title)}
			<div in:fly={{ y: 15, delay: 500, easing: sineInOut }} out:fade>
				<h2>
					{@html item.title}
				</h2>
				{#if item.excerpt}
					<p>
						{@html item.excerpt}
					</p>
				{/if}
				<a href={item.link} class="btn">
					<span>VIEW PROJECT</span>
					<div>
						<svg
							xmlns:svg="http://www.w3.org/2000/svg"
							xmlns="http://www.w3.org/2000/svg"
							version="1.1"
							x="0px"
							y="0px"
							viewBox="0 0 100 125">
							<g transform="translate(0,-952.36218)">
								<path
									style="text-indent:0;text-transform:none;direction:ltr;block-progression:tb;baseline-shift:baseline;color:#000000;enable-background:accumulate;"
									d="m 71.35934,1002.3622 -4.25,-4.25004 -29.99998,-30
									-8.4687,8.5 25.74993,25.75004 -25.74993,25.75 8.4687,8.5
									29.99998,-30 4.25,-4.25 z"
									fill="#000000"
									fill-opacity="1"
									stroke="none"
									marker="none"
									visibility="visible"
									display="inline"
									overflow="visible" />
							</g>
						</svg>
					</div>
					<span class="sr-only">View {item.title}</span>
				</a>
			</div>
		{/each}

		<div class="home-project-buttons">
			{#each projects as item, i}
				<button
					class:active={item === activeProject}
					on:click={() => (activeProject = item)}
					on:click={() => clearInterval(slideint)}>
					<span class="sr-only">project {i + 1}</span>
				</button>
			{/each}
		</div>
	</div>
</div>
